import { render } from "./AbsenceView.vue?vue&type=template&id=1d45e91d&scoped=true"
import script from "./AbsenceView.vue?vue&type=script&lang=js"
export * from "./AbsenceView.vue?vue&type=script&lang=js"

import "./AbsenceView.vue?vue&type=style&index=0&id=1d45e91d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d45e91d"]])

export default __exports__